export enum OTAssetLifecycleStatusEnum {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    DECOMMISSIONED = 'decommissioned',
    COLD_SPARE = 'cold_spare',
    HOT_SPARE = 'hot_spare',
}

type OTAssetStatusType = `${OTAssetLifecycleStatusEnum}`

export const AssetStatusToLabelMap: Record<OTAssetStatusType, string> = {
    active: 'Active',
    inactive: 'Inactive',
    decommissioned: 'Decommissioned',
    cold_spare: 'Cold Spare',
    hot_spare: 'Hot Spare',
}
